import { render, staticRenderFns } from "./InsurerRegistrationInfoForm.vue?vue&type=template&id=5a6451ba&"
import script from "./InsurerRegistrationInfoForm.vue?vue&type=script&lang=js&"
export * from "./InsurerRegistrationInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports